/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'

/**
 * アンケート回答保存の入力型。
scenarioId はパスから、設問文・選択肢ラベルはサーバ側で解決するため受け取らない。
回答は `(sessionId, questionId)` の行集合として置換保存される（SINGLE/MULTI/FREE 共通）。
 */
export interface SurveyResponseInput {
  /** リード（PII）項目（leadFieldKind 非null）の設問で入力された値。専用テーブルへ隔離保存される */
  leadValue?: string
  /** 自由記述（FREE 設問用）。リード項目の設問では無視 */
  freeText?: string
  /** 選択した選択肢ID。SINGLE=1件 / MULTI=複数 / FREE=空。リード項目の設問では無視 */
  optionIds?: Cuid[]
  /** 回答した設問ID */
  questionId: Cuid
  /** 回答した設問のノードキー */
  nodeKey: string
  /** 視聴セッションID（クライアント生成・回答の冪等キー） */
  sessionId: string
}
